import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import Magnetic from "@/components/Magnetic";
import LangToggle from "@/components/LangToggle";
import { useLang } from "@/i18n/LanguageContext";

const links = [
  { id: "#manifeste", key: "nav.manifeste", num: "01" },
  { id: "#projets", key: "nav.projets", num: "02" },
  { id: "#photo", key: "nav.photo", num: "03" },
  { id: "#contact", key: "nav.contact", num: "04" },
];

export default function Nav({ onNavigate }) {
  const [open, setOpen] = useState(false);
  const { t } = useLang();

  const go = (id) => {
    setOpen(false);
    setTimeout(() => onNavigate(id), 350);
  };

  return (
    <>
      <header className="fixed top-0 left-0 right-0 z-[100] flex items-center justify-between px-6 md:px-12 py-5">
        <Magnetic>
          <button
            data-testid="nav-logo"
            onClick={() => go("#top")}
            className="font-mono-tech text-xs tracking-[0.3em] text-[#E5E5E5] block px-2 py-1 drop-shadow-[0_1px_6px_rgba(5,5,5,0.9)]"
          >
            CR—L ©26
          </button>
        </Magnetic>
        <div className="flex items-center gap-5">
          <LangToggle />
          <Magnetic>
            <button
              data-testid="menu-toggle-button"
              onClick={() => setOpen(!open)}
              className="font-mono-tech text-xs tracking-[0.3em] text-[#E5E5E5] hover:text-[#75FB4E] transition-colors duration-300 block px-2 py-1"
            >
              {open ? t("menu.close") : t("menu.open")}
            </button>
          </Magnetic>
        </div>
      </header>

      <AnimatePresence>
        {open && (
          <motion.div
            data-testid="menu-overlay"
            className="fixed inset-0 z-[95] bg-[#050505] flex flex-col justify-center px-6 md:px-12"
            initial={{ clipPath: "inset(0 0 100% 0)" }}
            animate={{ clipPath: "inset(0 0 0% 0)" }}
            exit={{ clipPath: "inset(0 0 100% 0)" }}
            transition={{ duration: 0.7, ease: [0.76, 0, 0.24, 1] }}
          >
            <nav className="flex flex-col gap-2 md:gap-4">
              {links.map((link, i) => (
                <div key={link.id} className="overflow-hidden">
                  <motion.button
                    data-testid={`menu-link-${link.key.split(".")[1]}`}
                    onClick={() => go(link.id)}
                    className="group flex items-baseline gap-6 text-left"
                    initial={{ y: "110%" }}
                    animate={{ y: "0%" }}
                    exit={{ y: "110%" }}
                    transition={{ duration: 0.6, ease: [0.76, 0, 0.24, 1], delay: 0.15 + i * 0.08 }}
                  >
                    <span className="font-mono-tech text-sm text-[#75FB4E]">({link.num})</span>
                    <span className="font-display text-6xl md:text-8xl lg:text-9xl uppercase leading-none text-outline group-hover:text-[#75FB4E] transition-colors duration-300">
                      {t(link.key)}
                    </span>
                  </motion.button>
                </div>
              ))}
            </nav>
            <motion.div
              className="absolute bottom-8 left-6 md:left-12 flex flex-wrap gap-8 font-mono-tech text-[10px] tracking-widest text-[#808080]"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              transition={{ delay: 0.5 }}
            >
              <span>{t("menu.loc")}</span>
              <span>{t("menu.role")}</span>
              <span>©2026</span>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
    </>
  );
}
